// 一律使用 import type。此檔的職責是描述「怎麼載入」，
// 不得產生任何 runtime 依賴 —— 只要改成 value import，
// google-libphonenumber 的規則表就會回到 initial bundle。
import type * as PhoneNumberRules from './phone-number-rules';

/**
 * 動態載入 {@link PhoneNumberRules}（`google-libphonenumber`，未壓縮約 568 KB）。
 *
 * Promise 快取在 module 層級，多個呼叫端共用同一份 chunk 與同一份規則表。
 *
 * 失敗時清掉快取，但**不要期待它能救回下載失敗的 chunk**：本專案用
 * `@angular-devkit/build-angular:application`，lazy chunk 是原生 ESM 動態 import，
 * 抓取失敗會被瀏覽器的 module map 記錄下來，同一份文件內再 import 同一個
 * specifier 會直接以相同錯誤 reject，不會重新發出請求。
 * **真正的復原方式是重新整理頁面。**
 *
 * 這裡仍清掉快取，是為了處理「rejection 並非來自 module map 快取」的情況
 * （例如模組本身在求值階段丟出例外）。呼叫端不得把重試當成可靠的復原手段 ——
 * 兩個呼叫端目前都是載入失敗即放行（fail-open），理由見
 * `docs/perf-poc.md` §11 與 `docs/rd-verification-checklist.md` K4。
 */
let rulesPromise: Promise<typeof PhoneNumberRules> | null = null;

export function loadPhoneNumberRules(): Promise<typeof PhoneNumberRules> {
  if (!rulesPromise) {
    rulesPromise = import('./phone-number-rules').catch(error => {
      rulesPromise = null;
      throw error;
    });
  }

  return rulesPromise;
}
